module.exports = __webpack_public_path__ + "img/avatar_xiaolingling@3x.cc839a97.png";